import React from 'react';

export const FormActionButtons = ({ 
  onClose, 
  onCancel, 
  cancelText = "Cancel", 
  submitText = "Save Changes", 
  isLoading = false,
  formId,
  onSubmit,
  disabled = false,
  hideSubmit = false,
  containerClassName = "flex flex-col-reverse sm:flex-row items-center w-full gap-3 mt-6"
}) => {
  return (
    <div className={containerClassName}>
      <button
        type="button"
        onClick={onCancel || onClose}
        className="w-full sm:flex-1 cursor-pointer py-2.5 border border-slate-200 hover:bg-slate-50 text-slate-800 rounded-md text-[12px] font-semibold transition-all duration-300 ease-in-out shadow-sm bg-white"
      >
        {cancelText}
      </button>
      {!hideSubmit && (
        <button
          type={formId ? "submit" : "button"}
          form={formId}
          onClick={onSubmit}
          disabled={isLoading || disabled}
          className="w-full sm:flex-1 cursor-pointer py-2.5 min-h-[38px] bg-slate-900 hover:bg-black text-white rounded-md text-[12px] font-bold transition-all duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed border border-slate-900 shadow-sm"
        >
          {isLoading ? 'Saving...' : submitText}
        </button>
      )}
    </div>
  );
};
